import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const siteLinks = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "话题广场" },
  { to: "/polls", label: "投票风向" },
  { to: "/about", label: "关于我们" },
  { to: "/about#faq", label: "常见问题" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-300 bg-background-200">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                爆
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                爆料看点
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              把事件、评论区高能回复、网友神评论与投票结果放在同一个页面，让你一眼看清大家都在讨论什么。
            </p>
            <p className="mt-4 font-label text-xs leading-relaxed text-foreground-600">
              内容为网友观点汇聚整理，仅供参考与讨论。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
              话题分类
            </h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/topics?category=${category.slug}`}
                    className="cursor-pointer font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
              站内导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {siteLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
              联系与建议
            </h3>
            <ul className="mt-4 space-y-2.5 font-label text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-secondary-600">
                  <i className="ri-mail-line" aria-hidden="true" />
                </span>
                <a href="mailto:baoliao@example.com" className="cursor-pointer transition-colors hover:text-primary-600">
                  baoliao@example.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-secondary-600">
                  <i className="ri-chat-smile-2-line" aria-hidden="true" />
                </span>
                欢迎提供话题线索
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-secondary-600">
                  <i className="ri-refresh-line" aria-hidden="true" />
                </span>
                工作日 24 小时内回复
              </li>
            </ul>
            <Link
              to="/topics"
              className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-fire-line" aria-hidden="true" />
              </span>
              去看今日热榜
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 font-label text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 爆料看点 · 观点汇聚整理平台</p>
          <p>理性围观 · 观点并列 · 不代替任何一方的判断</p>
        </div>
      </div>
    </footer>
  );
}